import React, { useState, useEffect } from 'react';
import { Form, Field } from 'react-final-form';
import { Row, Col, ButtonToolbar, Button, Container, Card, CardBody } from 'reactstrap';
import { connect } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import axios from 'axios';
import { useDispatch, sendFlashMessage } from '@/shared/components/flash';
import ApiErrorMessage from '@/shared/components/ApiErrorMessage';
import CategoryKeywords from './components/CategoryKeywords';

const fetchCategory = async (organizationId, id) => {
    const response = await axios.get(`/organization/${organizationId}/category`);
    const categories = response.data.categories || [];
    return categories.find(c => String(c.id) === String(id));
};

const EditCategory = ({ organization }) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { id } = useParams();

    const [loading, setLoading] = useState(true);
    const [category, setCategory] = useState(null);

    useEffect(() => {
        if (!organization?.id) return;
        fetchCategory(organization.id, id)
            .then(result => {
                setCategory(result);
                setLoading(false);
            })
            .catch(error => {
                dispatch(sendFlashMessage(<ApiErrorMessage errors={error.response?.data} />, 'alert-danger'));
                setLoading(false);
            });
    }, [id, organization?.id, dispatch]);

    const onClickCancel = () => {
        history.push('/categories');
    };

    const onSubmit = values => {
        axios.put(`/organization/${organization.id}/category/${id}`, { name: values.name })
            .then(res => {
                if (res.status === 200) {
                    dispatch(sendFlashMessage('Category updated successfully', 'alert-success'));
                    history.push('/categories');
                }
            })
            .catch(error => {
                dispatch(sendFlashMessage(<ApiErrorMessage errors={error.response?.data} />, 'alert-danger'));
            });
    };

    if (loading || !category) return <p>Loading...</p>;

    return (
        <Container className="dashboard">
            <Row>
                <Col md={12}>
                    <Card>
                        <CardBody>
                            <Form onSubmit={onSubmit} validate={validate} initialValues={category}>
                                {({ handleSubmit, pristine, submitting }) => (
                                    <form className="form" onSubmit={handleSubmit}>
                                        <Row className="w100">
                                            <Col md="6">
                                                <h3 className="mb-4">Edit Category</h3>
                                            </Col>
                                            <Col md="6" className="text-right">
                                                <ButtonToolbar className="modal__footer flex justify-content-right w100">
                                                    <Button outline color="primary" className="mr-3" onClick={onClickCancel}>Cancel</Button>
                                                    <Button type="submit" disabled={submitting || pristine} color="primary">Save</Button>
                                                </ButtonToolbar>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md="6">
                                                <Field name="name">
                                                    {({ input, meta }) => (
                                                        <div className="form__form-group">
                                                            <span className="form__form-group-label">Category Name</span>
                                                            <div className="form__form-group-field">
                                                                <div className="form__form-group-row">
                                                                    <input type="text" {...input} placeholder="Category Name" />
                                                                    {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </Field>
                                            </Col>
                                        </Row>
                                    </form>
                                )}
                            </Form>
                            <Row>
                                <Col md="6">
                                    <CategoryKeywords
                                        organizationId={organization.id}
                                        categoryId={category.id}
                                        initialKeywords={category.keywords || []}
                                    />
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

const validate = values => {
    const errors = {};
    if (!values.name || !values.name.trim()) {
        errors.name = 'Category name is required';
    }
    return errors;
};

export default connect(state => ({
    organization: state.organization
}))(EditCategory);
